module.exports = __webpack_public_path__ + "img/mockup2.aa36feff.jpg";